import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "placa"
})
export class PlacaPipe implements PipeTransform {
    transform (value: string): string {
        if (value && value.length === 7) {
            return value.replace(/(\w{3})(\w{4})/, "$1-$2");
        }
        return value;
    }
}
